import { FilterValues } from "components/filters/FilterContext";
import { mapAppointmentTypeFilterToInstruction, mapAppointPhaseFilterToInstruction, mapArtistFilterToInstruction, mapProductionFilterToInstruction, mapQuarterFilterToInstruction, mapResponseToAppointmentPhaseFilter, mapResponseToAppointmentTypeFilter, mapResponseToArtistFilter, mapResponseToProductionFilter, mapResponseToQuarterFilter } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = ( 
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
): server.dto.PlanningByQuarterForExternalQuery => ({
  artistIds: mapArtistFilterToInstruction(filter.artist),
  productionIds: mapProductionFilterToInstruction(filter.production),
  phases: mapAppointPhaseFilterToInstruction(filter.appointmentPhase),
  appointmentTypes: mapAppointmentTypeFilterToInstruction(filter.appointmentType),
  date: mapQuarterFilterToInstruction(filter.quarter),
  cache: filterSet
});

export const mapResponseToFilterValues = (
  response: server.dto.PlanningByQuarterForExternalFilters,
  _: FilterValues
): Partial<FilterValues> => ({
  artist: mapResponseToArtistFilter(response.artists),
  production: mapResponseToProductionFilter(response.productions),
  appointmentPhase: mapResponseToAppointmentPhaseFilter(response.phases),
  appointmentType: mapResponseToAppointmentTypeFilter(response.appointmentTypes),
  quarter: mapResponseToQuarterFilter(response.date),
});
